import {
  FaAngular,
  FaBaseballBall,
  FaBook,
  FaCamera,
  FaCss3,
  FaDiscord,
  FaDocker,
  FaFigma,
  FaGithub,
  FaHeadphones,
  FaHtml5,
  FaInstagram,
  FaJava,
  FaJira,
  FaLinkedinIn,
  FaNodeJs,
  FaPlane,
  FaPython,
  FaReact,
  FaRunning,
  FaSwimmer,
  FaTwitter,
  FaUserShield,
} from "react-icons/fa";
import {
  SiAuth0,
  SiAxios,
  SiAzuredevops,
  SiBootstrap,
  SiDialogflow,
  SiDotnet,
  SiExpress,
  SiFirebase,
  SiFlask,
  SiJavascript,
  SiJsonwebtokens,
  SiKubernetes,
  SiMicrosoftazure,
  SiMiro,
  SiMongodb,
  SiMui,
  SiMysql,
  SiNotion,
  SiPostman,
  SiRedux,
  SiTailwindcss,
  SiTypescript,
} from "react-icons/si";
import { BsFiletypeScss, BsGithub } from "react-icons/bs";
import { BiLogoPostgresql } from "react-icons/bi";
import { DiGithubFull, DiMsqlServer } from "react-icons/di";
import {
  TbBrandReactNative,
  TbHexagonLetterC,
  TbBrandNextjs,
  TbBrandVscode,
  TbSquareLetterV,
  TbSettingsAutomation,
  TbApi,
  TbTestPipe,
} from "react-icons/tb";
import {
  MdAdminPanelSettings,
  MdSecurity,
  MdOutlineSecurity,
} from "react-icons/md";

import { RiShieldUserLine } from "react-icons/ri";

import { GiShield } from "react-icons/gi";

const logotext = "AK";
const meta = {
  title: "Asu Kaur",
  description: "Meet Asu Kaur!",
};

const introdata = {
  title: "I’m Asu Kaur",
  animated: {
    first: "I enjoy building apps that hackers can’t crack.",
    second: "I love reading.",
    third: "Curious learner, avid reader, travel enthusiast.",
  },
  description:
    "Postgrad from the University of Manchester with 5+ years of experience turning messy code into fortress-level software. I don’t just build apps — I build digital Fort Knoxes that hackers dread. If cyber threats were villains, consider me their ultimate nemesis (cape and all). When I’m not coding, I’m scheming new ways to keep your data safer than your grandma’s secret recipes. Welcome to my corner of the internet—secure, savvy, and just a little bit mischievous.",
  your_img_url: "/assets/images/grad.JPG",
};

const dataabout = {
  title: "Let me introduce myself",
  aboutme:
    "I am a postgraduate from the University of Manchester (UoM) with over 5 years of experience developing secure web and mobile applications, managing projects from inception to production. Specializing in Computer Security, I combine technical expertise with strong leadership skills honed through roles such as Deputy Head Girl, college event organizer, and technical team lead. Beyond technology, I’m passionate about basketball and swimming, and I find balance through reading, music, and travel — always driven by curiosity and a desire to grow.",
};

const dataacademic = {
  title: "A little about my education",
  aboutme:
    "I graduated high school with an outstanding 95%, actively participating in various school sports. In higher secondary, I achieved 92%, was a key member of the basketball team, and served as the Deputy Head Girl in the student council. I later earned a BTech degree in Computer Science & Engineering with a GPA of 9.22, balancing my passion for sports and event planning. Recently, I graduated with an MSc in Advanced Computer Science with a specialization in Computer Security from the University of Manchester with an incredible score of 76%",
};

const datawork = {
  title: "A little about my work",
  aboutme:
    "I embarked on my professional journey in August 2020 as a technical writer intern during my undergraduate studies. In early 2021, I transitioned into web development, steadily progressing through multiple roles until I became a Senior Full Stack Lead. During that time, I led the end-to-end development of web and mobile applications while mentoring junior team members. I am actively seeking a security-focused leadership role where I can apply my 4+ years of hands-on experience and passion for building secure, scalable systems.",
};
const personalTimeline = [
  {
    name: "Graduated University",
    when: "December 2025",
  },
  {
    name: "Started Postgrad",
    when: "September 2024",
  },
  {
    name: "Graduated College",
    when: "August 2021",
  },
  {
    name: "Started Professional Career",
    when: "March 2021",
  },
  {
    name: "Graduated Higher Secondary",
    when: "April 2017",
  },
  {
    name: "Graduated High School",
    when: "March 2015",
  },
  // {
  //   name: "Born",
  //   when: "March, 1999",
  // },
];

const education = [
  {
    name: "Master of Science in Advanced Computer Science: Computer Security",
    where: "The University of Manchester, Manchester",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>Graduated with a 76%. </li>{" "}
        <li>
          Proud recipient of the Bicentary Global Futures Scholarship, awarded
          for academic excellence and community contribution.
        </li>{" "}
        <li>
          Awarded the Stellify Award in recognition of leadership, social
          responsibility, and extracurricular contribution beyond academics
        </li>
        <li>
          Academic Representative at the University of Manchester, bridging
          communication between students and faculty to enhance academic
          experiences.
        </li>{" "}
        <li>
          Collaborated in diverse group projects, strengthening teamwork and
          communication skills.
        </li>{" "}
        <li>
          Volunteer at Willow Bank Project, supporting children under 13 with
          educational and recreational activities.
        </li>{" "}
        <li>
          Assisted Manchester Museum during British Science Week, helping engage
          visitors and promote science outreach.
        </li>
      </ul>
    ),
    when: "2025",
    marks: "",
  },
  {
    name: "Bachelor of Technology in Computer Science & Engineering",
    where: "Maulana Abul Kalam Azad University of Technology, West Bengal",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>Graduated with a GPA of 9.22/10. </li>{" "}
        <li>
          Organized Fresher’s Day event in 2nd year, welcoming and engaging new
          students in campus life.
        </li>{" "}
        <li>
          Served as Head Organizer for Teacher’s Day celebrations in 3rd year,
          coordinating event planning and execution.{" "}
        </li>{" "}
        <li>
          Active member of the ECA Club, helping organize various cultural and
          extracurricular events across the college.{" "}
        </li>{" "}
        <li>
          Led the organization of a successful blood donation drive, promoting
          health awareness and community service.{" "}
        </li>
      </ul>
    ),
    when: "2021",
    marks: "9.22",
  },
  {
    name: "Indian School Certificate",
    where: "M.P. Birla Foundation H.S. School",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Graduated with a score of 93% from Council for the Indian School
          Certificate Examinations (CISCE).{" "}
        </li>{" "}
        <li>
          Deputy Head Girl of the Student Council, leading a team of 52+ members
          by delegating daily tasks and organizing inter-school and intra-school
          activities.{" "}
        </li>{" "}
        <li>
          Member of the school basketball team, demonstrating teamwork and
          dedication.
        </li>{" "}
        <li>
          Captain of the house basketball team, providing on-court leadership
          and strategy.{" "}
        </li>{" "}
        <li>
          Coach of the house basketball team, mentoring players and guiding the
          team to win the intra-school basketball tournament.{" "}
        </li>
      </ul>
    ),
    when: "2017",
    marks: "92%",
  },
  {
    name: "Indian Certificate of Secondary Education",
    where: "M.P. Birla Foundation H.S. School",
    when: "2015",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Graduated with a score of 95% from Council for the Indian School
          Certificate Examinations (CISCE).{" "}
        </li>{" "}
      </ul>
    ),
    marks: "95%",
  },
];
const worktimeline = [
  {
    name: "Software Engineer",
    where: "Paperpost Limited",
    when: "September 2025 -  Present",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Leading the end-to-end modernization of a legacy .NET monolith into a
          scalable, cloud-native architecture using React, .NET Core, EF Core,
          Docker, Kubernetes, and Azure
        </li>
        <li>
          Designed, developed, and deployed a custom Microsoft Word Add-in to
          automate document submission and printing through the enterprise print
          console, streamlining document workflows and successfully rolling out
          the solution across multiple Microsoft 365 tenant environments
        </li>
        <li>
          Rebuilding the frontend from scratch in React with Redux, implementing
          modern state management, modular architecture, and secure coding best
          practices
        </li>
        <li>
          Ensuring feature parity while improving UX, performance, and
          maintainability across the new application
        </li>
        <li>
          Optimizing legacy stored procedures, reducing query execution time and
          improving API response performance
        </li>
        <li>
          Migrating database models into code using Entity Framework Core,
          improving maintainability and enabling cleaner domain-driven structure
        </li>{" "}
        <li>
          Refactoring and securing REST APIs, implementing validation, error
          handling, and improved response efficiency
        </li>
        <li>
          Containerizing frontend and backend services using Docker and
          orchestrating deployments with Kubernetes
        </li>
        <li>
          Designing and implementing CI/CD pipelines (Azure) to automate builds,
          testing, and production deployments
        </li>
        <li>
          Embedding secure coding standards and testing frameworks across
          frontend and backend to reduce vulnerabilities and increase
          reliability
        </li>
        <li>
          Improving UI/UX to enhance usability and align with modern product
          standards{" "}
        </li>
      </ul>
    ),
  },
  // {
  //   name: "Academic Representative",
  //   where: "The University of Manchester",
  //   when: "October 2024 - September 2025",
  //   description: (
  //     <ul style={{ listStyle: "disc" }}>
  //       <li>
  //         Advocated for the interests and needs of the student cohort, acting as
  //         a bridge between students and faculty to foster a collaborative and
  //         productive academic environment.
  //       </li>
  //       <li>
  //         Chaired meetings and participated in departmental discussions,
  //         presenting constructive feedback and proposing improvements to
  //         coursework, assessments, and resources.
  //       </li>
  //       <li>
  //         Worked closely with staff and peers to identify and implement changes
  //         that enhanced the learning experience and promoted greater student
  //         satisfaction.
  //       </li>
  //       <li>
  //         Developed strong leadership, teamwork, and communication skills while
  //         representing the voice of students within the department.
  //       </li>
  //     </ul>
  //   ),
  // },
  {
    name: "Lead Full Stack Engineer",
    where: "Caarya",
    when: "November 2024 - December 2024",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Led code review sessions emphasizing secure coding practices and
          vulnerability mitigation to maintain application integrity.
        </li>
        <li>
          Mentored junior developers on secure development principles and
          encouraged adoption of best security standards in both frontend and
          backend code.{" "}
        </li>
        <li>
          Guided the team in implementing security-focused design patterns and
          reviewing architectural decisions for potential risks.
        </li>
        <li>
          Managed task distribution and progress tracking with flexibility to
          accommodate part-time availability and academic commitments.{" "}
        </li>
        <li>
          Collaborated with stakeholders to prioritize security features and
          fixes alongside functional development during sprint planning.{" "}
        </li>{" "}
        <li>
          Provided constructive feedback to improve not only code quality but
          also security posture without compromising development velocity.{" "}
        </li>
        <li>
          Supported junior team members in balancing workload and learning
          objectives while maintaining secure coding standards.
        </li>
      </ul>
    ),
  },
  {
    name: "Lead Full Stack Engineer",
    where: "Caarya",
    when: "July 2022 - November 2024",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Spearheaded the successful delivery of 12 projects and managed 16
          ongoing projects, ensuring on‑time delivery and aligning with client
          objectives.{" "}
        </li>
        <li>
          Directed and mentored a multidisciplinary team of ~30 developers, 4
          designers, and 6 project managers, ensuring seamless collaboration and
          high‑quality output across departments.{" "}
        </li>
        <li>
          Partnered with the CEO and CTO to define long‑term objectives, setting
          weekly and monthly milestones for the Tech department, and worked
          closely with Project and Product Managers to establish daily and
          weekly team deliverables.{" "}
        </li>
        <li>
          Orchestrated client meetings to clearly define project scope and
          requirements, facilitating effective communication across design,
          development, and management teams.{" "}
        </li>
        <li>
          Evaluated and conducted technical interviews for junior developers and
          interns, selecting top talent to support ongoing projects and foster
          growth within the team.
        </li>{" "}
        <li>
          Served as a mentor to junior Full‑Stack, Frontend, and Backend
          developers, providing guidance for professional development and skill
          enhancement.{" "}
        </li>
        <li>
          Oversaw deployment across environments, conducted regular code
          reviews, and ensured up‑to‑date technical documentation across
          projects.{" "}
        </li>
        <li>
          Created and enforced security‑first architecture across 16 enterprise
          applications, aligning with OWASP guidelines and secure coding
          standards.{" "}
        </li>
        <li>
          Implemented IAM systems with role‑based access control (RBAC),
          JWT‑based token authentication, and robust secure session handling.{" "}
        </li>
        <li>
          Spearheaded internal security reviews, developed threat models, and
          implemented least‑privilege access policies across environments.
        </li>
      </ul>
    ),
  },
  {
    name: "Full Stack Engineer",
    where: "Caarya",
    when: "January 2022 - July 2024",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Spearheaded and led a team of approximately 20–25 members in the
          design, development, and delivery of UI components and RESTful APIs
          across a range of internal and external applications.{" "}
        </li>
        <li>
          Developed 16 Progressive Web Apps (PWAs) utilizing service workers and
          caching strategies, significantly enhancing user experience and
          application performance.{" "}
        </li>
        <li>
          Engaged in client meetings to gather requirements, define technical
          specifications, and align team efforts with project objectives.{" "}
        </li>
        <li>
          Evaluated and conducted technical interviews for junior developers and
          interns, ensuring the onboarding of highly capable team members.{" "}
        </li>
        <li>
          Oversaw the end-to-end software development lifecycle—from
          conceptualization and design to deployment and ongoing maintenance—for
          internal and client-focused projects.{" "}
        </li>
        <li>
          Developed secure RESTful APIs with robust input validation, structured
          error handling, and implemented JWT and OAuth2 for authentication and
          authorization.{" "}
        </li>
        <li>
          Integrated secure third‑party APIs while enforcing HTTPS, CSP, and
          CORS policies for enhanced application security.{" "}
        </li>
        <li>
          Created role‑based deployment environments with access controls and
          implemented secure Git workflows.
        </li>
        <li>
          Collaborated on .NET‑based backend services for reporting systems,
          ensuring seamless and secure data transmission across services.
        </li>
        <li>
          Reviewed peer code with a focus on identifying security
          vulnerabilities, improving code quality, and ensuring best practices
          across the team.
        </li>
      </ul>
    ),
  },
  {
    name: "Frontend Engineer",
    where: "Caarya",
    when: "April 2021 - December 2021",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          {" "}
          Led and successfully delivered 4 major frontend projects, driving
          innovation and enhancing user experience.{" "}
        </li>
        <li>
          {" "}
          Managed a team of 5 developers, overseeing UI component development,
          feature integration, and ensuring cross-device responsiveness using
          modern frontend technologies.{" "}
        </li>
        <li>
          {" "}
          Refactored complex codebases to boost maintainability, scalability,
          application performance and prevent common frontend vulnerabilities
          (e.g., XSS, clickjacking){" "}
        </li>
        <li>
          {" "}
          Developed fully responsive, performant web interfaces compatible
          across diverse devices and browsers.{" "}
        </li>
        <li>
          {" "}
          Mentored and upskilled 4 junior engineers, improving team productivity
          and code quality.{" "}
        </li>
        <li>
          {" "}
          Owned deployment workflows and conducted rigorous code reviews,
          enforcing coding standards and best practices.
        </li>
        <li>
          Utilized technologies including React.js, CSS3, JavaScript ES6+, Git,
          and CI/CD pipelines to deliver robust frontend solutions.
        </li>
      </ul>
    ),
  },
  {
    name: "Full Stack Developer - Trainee",
    where: "Caarya",
    when: "March 2021 - April 2021",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Created and developed new UI components to enhance the application's
          user interface, improving usability and visual appeal.
        </li>{" "}
        <li>
          Successfully integrated the frontend application with backend APIs,
          ensuring smooth communication and reliable data exchange.
        </li>{" "}
        <li>
          Implemented client-side search functionality, enabling users to
          efficiently search and retrieve relevant information.
        </li>{" "}
        <li>
          Conducted code refactoring to identify and eliminate potential bugs,
          significantly improving code quality and application stability.
        </li>{" "}
        <li>
          Collaborated with senior developers to understand project requirements
          and contribute to design, coding, and testing phases.
        </li>{" "}
        <li>
          Supported troubleshooting and debugging efforts to enhance application
          performance and user experience.
        </li>{" "}
        <li>
          Engaged in continuous learning to develop technical skills and deepen
          understanding of the software development lifecycle.
        </li>
      </ul>
    ),
  },
];

const projects = [
  {
    name: "H.K. Company — Business Website & HKCO Payload Backend",
    where: "Volunteer",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Volunteered to develop a responsive B2B website and a secure internal
          administration platform for H.K. Company, a leading railway and
          defence manufacturer in India.
        </li>
        <li>
          Built the public website with React, TypeScript, Vite, Tailwind CSS,
          shadcn/ui, Radix UI, React Router, and Lucide icons, with reusable
          components, mobile navigation, and Firebase Hosting configuration.
        </li>
        <li>
          Showcased the company's manufacturing heritage, certifications,
          capabilities, global export presence, and 10 industrial product
          categories. Implemented searchable pressure gauge listings with
          availability filters and product dialogs featuring image carousels,
          specifications, applications, and certifications using sample
          catalogue data.
        </li>
        <li>
          Integrated an EmailJS inquiry form with submission feedback and error
          handling to support product discovery and customer inquiries.
        </li>
        <li>
          Developed HKCO Payload Backend using Payload CMS, Next.js, TypeScript,
          PostgreSQL, Drizzle ORM, and Tailwind CSS. Implemented secure
          authentication, server-side authorization for Admin, HR, and Store
          roles, and role-aware dashboards and admin navigation.
        </li>
        <li>
          Created workflows for employees, HR, departments, many-to-many teams,
          clients, website content, products and categories, inventory movements
          and stock audit trails, machinery maintenance, and certificate and
          license expiry tracking, with audit logging for key admin actions.
        </li>
        <li>
          Designed a centralized FileService for direct browser-to-Cloudflare R2
          uploads, public and private visibility, signed private downloads, file
          replacement, deletion, and access control. Stored file metadata and
          relationships in PostgreSQL while keeping file binaries in R2.
        </li>
        <li>
          Structured the backend for production deployment with reusable
          services, Lucide product category icon selection, explicit database
          synchronization through pnpm db:sync, and Docker Compose support for
          local PostgreSQL.
        </li>
      </ul>
    ),
  },
  {
    name: "HPOD Selfservice",
    where: "Paperpost",
    when: "Aug 2025 - Present",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Leading the end-to-end modernization of a legacy .NET monolith into a
          scalable, cloud-native architecture using React, .NET Core, EF Core,
          Docker, Kubernetes, and Azure
        </li>
        <li>
          Rebuilding the frontend from scratch in React with Redux, implementing
          modern state management, modular architecture, and secure coding best
          practices
        </li>
        <li>
          Ensuring feature parity while improving UX, performance, and
          maintainability across the new application
        </li>
        <li>
          Optimizing legacy stored procedures, reducing query execution time and
          improving API response performance
        </li>
        <li>
          Migrating database models into code using Entity Framework Core,
          improving maintainability and enabling cleaner domain-driven structure
        </li>{" "}
        <li>
          Refactoring and securing REST APIs, implementing validation, error
          handling, and improved response efficiency
        </li>
        <li>
          Improving UI/UX to enhance usability and align with modern product
          standards{" "}
        </li>
      </ul>
    ),
  },
  {
    name: "Chronos - Caarya Suite of Products",
    where: "Caarya",
    when: "Dec 2021 - Dec 2024",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Spearheaded the development of 20 diverse applications utilizing
          React, Redux Toolkit, TailwindCSS, and SASS, ensuring consistent
          quality and adherence to best practices.
        </li>
        <li>
          Assumed responsibility for the backend APIs, implementing robust
          authentication and IAM (Identity and Access Management) solutions
          across all 20 applications.
        </li>
        <li>
          Conducted codebase refactoring to enhance readability, reusability,
          and code optimization, resulting in improved maintainability and
          performance.
        </li>
        <li>
          Leveraged Redux Toolkit to efficiently manage user permissions and
          dynamically render different portal layouts based on authorized
          access.
        </li>
        <li>
          Transformed all applications into Progressive Web Apps (PWAs) by
          leveraging service workers and caching mechanisms, enhancing offline
          capabilities and user experience.
        </li>
        <li>
          Developed a Discord bot using Discord.js and Python that offers
          analytical statistics and daily task management capabilities to users
          upon command.
        </li>
        <li>
          Seamlessly integrated Dialogflow and Google APIs into the
          applications, leveraging intent recognition capabilities to enable
          intelligent conversational interactions, provide accurate feedback,
          and unlock additional functionality.
        </li>
      </ul>
    ),
  },

  {
    name: "Txt Eld",
    where: "Caarya",
    when: "Aug 2022 - Jun 2023",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Implemented a PDF and CSV emailing feature using .NET, allowing users
          to generate and send PDF and CSV files via email seamlessly.
        </li>
        <li>
          Developed robust APIs in .NET and seamlessly integrated them into an
          Angular application, facilitating smooth data exchange and
          communication between the frontend and backend.
        </li>
        <li>
          Designed and developed UI components for the Angular application,
          ensuring a visually appealing and userfriendly interface.
        </li>
      </ul>
    ),
  },
  {
    name: "BackBone",
    where: "Caarya",
    when: "Jul 2022 - June 2023",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Led a team of 10 developers and a designer, successfully coordinating
          efforts to meet client requirements and deliver high-quality
          solutions.
        </li>
        <li>
          Collaborated with the client, as well as the design and development
          team, to ensure effective communication and alignment throughout the
          project lifecycle.
        </li>
        <li>
          Collaborated closely with the Product Manager to establish clear
          deliverable timelines, effectively planning and prioritizing daily
          tasks and weekly goals for the team to ensure efficient project
          execution.
        </li>

        <li>
          Provided supervision and guidance in the development of UI components
          and APIs, overseeing code deployments to various environments, and
          conducting regular testing across all environments.
        </li>
        <li>
          Assumed responsibility for deployments and database migrations to
          different environments, while conducting daily code reviews to
          maintain optimal code quality.
        </li>
        <li>
          Managed a team of 6-7 developers over a period of one and a half
          months, successfully overseeing the development of the entire admin
          panel.
        </li>

        <li>
          Integrated Stripe APIs to facilitate seamless payment processing.
        </li>
      </ul>
    ),
  },
  {
    name: "Ramgarhia Sewak Sabha Kolkata",
    where: "Volunteer",
    when: "May 2022",
    link: "https://ramgarhiasewaksabhakolkata.com/",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Created a user-friendly interface and enhanced the digital presence of
          the Ramgarhia Sewak Sabha Kolkata, an organization for the Ramgarhia
          Sikh community in Kolkata.
        </li>
      </ul>
    ),
  },
  {
    name: "Vapra",
    where: "Caarya",
    when: "Mar 2022 - Jan 2023",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Led a team of 10 developers, fostering collaboration and coordination
          between the client, design team, and development team to successfully
          meet project requirements.
        </li>
        <li>
          Collaborated with the Project Manager to establish deliverable
          timelines, daily tasks, and weekly goals, ensuring efficient project
          execution and timely delivery.
        </li>{" "}
        <li>
          Provided supervision and guidance in regular code deployments to
          multiple environments, conducted thorough testing across various
          platforms, and oversaw the development of UI components and APIs.
        </li>{" "}
        <li>
          Reviewed and restructured the database architecture to align with
          client requirements, managing deployments and database migrations to
          different environments.
        </li>{" "}
        <li>
          Developed a user-friendly UI for displaying reports generated by
          Quickbooks APIs, enabling users to download them in PDF, Docx, and
          Excel formats.
        </li>{" "}
        <li>
          Implemented a robust Document Generation feature with over 100
          templates, allowing users to quickly generate documents in less than 5
          minutes.
        </li>{" "}
        <li>
          Oversaw the development of a React Native Android application,
          ensuring adherence to quality standards and timely delivery.
        </li>
      </ul>
    ),
  },
  {
    name: "SAKSHAM",
    where: "Caarya",
    when: "Aug 2021 - Jan 2023",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Demonstrated strong leadership skills by effectively leading a team of
          6 developers, ensuring smooth coordination and collaboration to meet
          client requirements and deliver exceptional solutions.
        </li>
        <li>
          Developed 3 applications and 2 donation apps, leveraging HTML, CSS,
          React, and TailwindCSS to create engaging user experiences while
          adhering to project specifications.
        </li>
        <li>
          Successfully integrated the Razorpay payment gateway with the Python
          backend, enabling secure and efficient processing of payments for
          enhanced user convenience.
        </li>
      </ul>
    ),
  },

  {
    name: "Sportzi - Sports Infotainment Website",
    where: "Caarya",
    when: "Aug 2021 - Sep 2021",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Led a dedicated development team of 3 members, overseeing the
          development of new UI components, integration of new feature sets, and
          maintenance of responsiveness for both the website and admin portal.
        </li>
        <li>
          Facilitated effective communication between the frontend and backend
          teams, ensuring seamless collaboration and information exchange.
        </li>
        <li>
          Collaborated with the Product and Project Managers to establish
          deliverable timelines for the project, ensuring timely completion of
          tasks and milestones.
        </li>
        <li>
          Skilfully planned daily tasks for team members, optimizing
          productivity and resource allocation.
        </li>
        <li>
          Conducted code refactoring to enhance code readability, reusability,
          and optimization, resulting in improved maintainability and
          performance.
        </li>

        <li>
          Designed new screens for the Football section of the website, ensuring
          a visually appealing and user-friendly experience.
        </li>
        <li>
          Integrated a Live updates feature using Socket.io, enabling real-time
          updates and enhanced interactivity.
        </li>
      </ul>
    ),
  },
  {
    name: "Client Projects",
    where: "Caarya",
    when: "Mar 2021 - Sep 2022",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Independently developed websites for 5 diverse clients, utilizing
          technologies such as React, Redux, SASS, CSS, TailwindCSS, and Next.js
          to deliver customized and engaging online experiences.
        </li>
        <li>
          Developed 5 robust admin panels using React, Redux Toolkit, and
          TailwindCSS, providing clients with efficient tools to manage and
          organize their organizational data effectively.
        </li>
        <li>
          Assumed responsibility for the deployment of all websites to various
          environments, ensuring seamless transition and optimal performance.
        </li>
        <li>
          Designed and developed new UI components, enhancing the visual appeal
          and usability of the application.
        </li>
        <li>
          Conducted code refactoring to identify and eliminate potential bugs,
          improving the stability and performance of the application.
        </li>
      </ul>
    ),
  },
];

const involvements = [
  {
    name: "Volunteer",
    where: "Manchester Museum",
    when: "Mar 2025",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Guided middle school students (ages 11–14) through curated gallery
          tours during British Science Week, helping connect exhibits to
          STEM-based educational themes in accessible language.
        </li>
        <li>
          Supported art-integrated learning activities, fostering engagement
          through visual storytelling and interactive exercises.
        </li>
        <li>
          Collaborated with museum staff and teachers to ensure a safe,
          inclusive, and educational environment, enhancing pupils'
          understanding of biological and environmental sciences.{" "}
        </li>
      </ul>
    ),
  },
  {
    name: "Volunteer - Willow Bank Project",
    where: "The University of Manchester",
    when: "Feb 2025 - May 2025",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          {" "}
          Supported community outreach initiatives by engaging with children
          under the age of 13, facilitating educational and recreational
          activities.{" "}
        </li>
        <li>
          {" "}
          Fostered a safe, inclusive, and supportive environment to encourage
          learning and social development.{" "}
        </li>
        <li>
          {" "}
          Collaborated with fellow volunteers and project coordinators to plan
          and deliver impactful sessions.{" "}
        </li>
        <li>
          {" "}
          Developed strong interpersonal, communication, and teamwork skills
          through direct interaction with children and community members.{" "}
        </li>
        <li>
          Contributed to enhancing community well-being and promoting social
          inclusion.{" "}
        </li>
      </ul>
    ),
  },
  {
    name: "Academic Representative - MSc ACS Department",
    where: "The University of Manchester",
    when: "Oct 2024 - Sept 2025",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Advocated for the interests and needs of the student cohort, acting as
          a bridge between students and faculty to foster a collaborative and
          productive academic environment.{" "}
        </li>
        <li>
          Chaired meetings and participated in departmental discussions,
          presenting constructive feedback and proposing improvements to
          coursework, assessments, and resources.{" "}
        </li>
        <li>
          Worked closely with staff and peers to identify and implement changes
          that enhanced the learning experience and promoted greater student
          satisfaction.{" "}
        </li>
        <li>
          Developed strong leadership, teamwork, and communication skills while
          representing the voice of students within the department.
        </li>
      </ul>
    ),
  },
  {
    name: "Volunteer - GreatUniHack 2024",
    where: "UniCS Manchester",
    when: "Oct 2024",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Supported the organization and smooth execution of GreatUniHack 2024,
          a large-scale hackathon event for university students.{" "}
        </li>
        <li>
          Assisted participants with technical and logistical support, ensuring
          a positive and productive hackathon experience.{" "}
        </li>
        <li>
          Coordinated with event organizers and volunteers to manage schedules,
          troubleshoot issues, and facilitate communication.{" "}
        </li>
        <li>
          Developed skills in event coordination, teamwork, problem-solving, and
          effective communication within a fast-paced environment.{" "}
        </li>
        <li>
          Contributed to fostering an inclusive and collaborative atmosphere
          that encouraged innovation and learning.{" "}
        </li>
      </ul>
    ),
  },
  {
    name: "Core Member - Google Developer's Student Club",
    where: "Techno International Batanagar",
    when: "Aug 2020 - Jul 2021",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Actively participated in weekly planning sessions for the club,
          contributing ideas and insights to develop strategies and initiatives.
        </li>
        <li>
          Assumed responsibility for content creation related to upcoming
          events, ensuring engaging and informative materials for promotion and
          communication purposes.
        </li>
        <li>
          Skilfully created graphics for social media platforms, effectively
          capturing the club's message and attracting attention from the target
          audience.
        </li>
      </ul>
    ),
  },
  {
    name: "Organizer - Extra Curricular Activities Club",
    where: "Techno International Batanagar",
    when: "Jul 2018 - Mar 2020",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Led the successful organization of the Freshers Welcome Program,
          orchestrating a seamless and engaging onboarding experience for the
          incoming 2018 batch of newcomers.
        </li>
        <li>
          Took an active role in the planning and execution of the annual sports
          event for the year 2019, contributing to the seamless coordination of
          various activities and ensuring a successful and memorable experience
          for all participants.
        </li>
        <li>
          Took charge of planning and executing the Teachers' Day program in
          September 2019, ensuring a memorable and appreciative event for the
          school's educators.
        </li>
        <li>
          Actively contributed to the coordination and execution of the blood
          donation camp in both 2018 and 2019, supporting a vital community
          initiative.
        </li>
      </ul>
    ),
  },
  {
    name: "Master of Ceremonies - Akshay Urja Diwas",
    where: "Techno International Batanagar",
    when: "Aug 2018",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Demonstrated exceptional skills as a Master of Ceremonies, seamlessly
          guiding and engaging audiences through various event segments.
        </li>
        <li>
          Displayed confident and charismatic stage presence, enhancing the
          event's atmosphere and leaving a lasting positive impression.
        </li>
        <li>
          Maintained a well-paced event timeline, coordinating with performers,
          speakers, and technical teams to ensure seamless transitions and
          timely execution.
        </li>
        <li>
          Navigated unexpected situations and last-minute changes with
          composure, quick thinking, and efficient problem-solving skills.
        </li>
        <li>
          Collaborated closely with event organizers, vendors, and performers to
          align event vision, ensuring a cohesive and successful overall
          production.
        </li>
        <li>
          Demonstrated a professional demeanour at all times, upholding event
          standards and contributing to a positive and memorable event
          experience.
        </li>
      </ul>
    ),
  },
  {
    name: "Volunteer - Medical Check-up Camp",
    where: "Kolkata Sikh Nari Manch",
    when: "Jul 2017 - Aug 2017",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Successfully organized and coordinated medical check-up camps,
          ensuring seamless logistical arrangements and a smooth flow of
          operations.
        </li>
        <li>
          Actively participated in promoting health awareness by offering free
          medical services, contributing to community well-being and preventive
          care.
        </li>
        <li>
          Collaborated effectively with a multidisciplinary team of healthcare
          professionals, contributing to the collective effort in providing
          quality medical services.
        </li>
        <li>
          Actively engaged with camp attendees, answering queries, and
          addressing concerns, fostering positive relationships and enhancing
          the camp's impact.
        </li>
      </ul>
    ),
  },
  {
    name: "Deputy Head Girl - Student Council",
    where: "M. P. Birla Foundation H.S. School",
    when: "Jul 2015 - Aug 2016",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Served as a representative for the school, actively participating and
          representing the institution in various school events.{" "}
        </li>
        <li>
          Demonstrated strong leadership skills by effectively managing a
          council of 52 students, overseeing their day-today school duties and
          responsibilities.
        </li>
        <li>
          Successfully organized a variety of inter-school and intra-school
          events throughout the year, delegating tasks and responsibilities to
          student council members, ensuring smooth execution and memorable
          experiences for all participants.
        </li>
      </ul>
    ),
  },
  {
    name: "Basketball Player",
    where: "M. P. Birla Foundation H.S. School",
    when: "Jun 2014 - Dec 2016",
    description: (
      <ul style={{ listStyle: "disc" }}>
        <li>
          Participated as a dedicated member of the school team, showcasing my
          skills and commitment on the field in both the years 2014 and 2015.
        </li>
        <li>
          Led the house basketball team as captain during the intra-school
          tournament, guiding the team to a commendable second-place position
          through effective leadership and a display of sportsmanship in 2015.
        </li>
        <li>
          As coach, led the house basketball team to a first-place victory in
          the intra-school tournament of 2016, fostering skill development and
          teamwork.
        </li>
      </ul>
    ),
  },
];

const certifications = [
  {
    name: "Microsoft Certified: Security, Compliance, and Identity Fundamentals",
    where: "Microsoft",
    when: "Jun 2025",
    description: (
      <p>
        Skills: Information Protection · Microsoft Azure · Information Security
        · Role-Based Access Control (RBAC) · Compliance Management · Information
        Security Governance · Cloud Security · JSON Web Token (JWT) · Security
        Management · OAuth · Security · Identity and Access Management (IAM) ·
        Network Security",
      </p>
    ),
  },
  {
    name: "Java Programming and Software Engineering Fundamentals Specialization",
    where: "Coursera (Duke University)",
    when: "2020",
    description: (
      <p>
        Includes the following modules: Arrays, Lists, and Structured Data,
        Programming Foundations with JavaScript, HTML and CSS, Solving Problems
        with Software, Principles of Software Design, Building a Recommendation
        System
      </p>
    ),
  },
  {
    name: "The Bits and Bytes of Computer Networking",
    where: "Coursera (Google)",
    when: "2020",
    description: null,
  },
  {
    name: "Version Control with Git",
    where: "Coursera (Atlassian)",
    when: "2020",
    description: null,
  },
  {
    name: "Introduction to Git and GitHub",
    where: "Coursera (Google)",
    when: "2020",
    description: null,
  },
  {
    name: "Big Data - Hadoop",
    where: "Sikharty Educational Service",
    when: "2019",
    description: null,
  },
  {
    name: "Seminar on Blockchain & Recent Trends in Computing",
    where: "Association for Computing Machinery & Computer Society of India",
    when: "2019",
    description: null,
  },
  {
    name: "Core Java",
    where: "Techno International Batanagar",
    when: "2018",
    description: null,
  },
  {
    name: "PHP MYSQL with HTML CSS",
    where: "NIEDC Entrepreneurship Development Training Programme",
    when: "2018",
    description: null,
  },
];

const dataportfolio = [
  "/assets/images/snap/13.jpg",
  //   "/assets/images/snap/4.jpg",
  "/assets/images/snap/12.jpg",
  "/assets/images/snap/6.jpg",
  "/assets/images/snap/3.jpg",

  "/assets/images/snap/11.jpg",
  "/assets/images/snap/9.jpg",

  "/assets/images/snap/7.jpg",
  "/assets/images/snap/2.jpg",

  "/assets/images/snap/14.jpg",

  //   "/assets/images/snap/8.jpg",
  "/assets/images/snap/10.jpg",

  "/assets/images/snap/1.jpg",
];

const contactConfig = {
  YOUR_EMAIL: "iamasukaur@gmail.com",
  YOUR_NUMBER: "(+44) 7587678917",
  description:
    "I'm thrilled to connect. Whether you have a project in mind, want to collaborate, or just fancy a chat, I'm all ears. Feel free to drop me a message below, and I'll get back to you as soon as possible. Looking forward to hearing from you!",
  YOUR_SERVICE_ID: "service_id",
  YOUR_TEMPLATE_ID: "template_id",
  YOUR_USER_ID: "user_id",
};

const socialprofils = {
  github: "https://github.com/AsuKaur",
  facebook: "",
  linkedin: "https://www.linkedin.com/in/asukaur/",
  twitter: "https://twitter.com/asu_kaur?lang=en",
  instagram: "https://www.instagram.com/asu.kaur/",
};

const connectList = [
  {
    name: "@AsuKaur",
    icon: (
      <>
        <FaGithub />
      </>
    ),
    link: "https://github.com/AsuKaur",
  },
  {
    name: "@asukaur",
    icon: (
      <>
        <FaLinkedinIn />
      </>
    ),
    link: "https://www.linkedin.com/in/asukaur/",
  },
  {
    name: "@asu_kaur",
    icon: (
      <>
        <FaTwitter />
      </>
    ),
    link: "https://twitter.com/asu_kaur?lang=en",
  },
  {
    name: "@asu.kaur",
    icon: (
      <>
        <FaInstagram />
      </>
    ),
    link: "https://www.instagram.com/asu.kaur/",
  },
];

const pivotnexploreList = [
  {
    name: "@pivotandexplore",
    icon: (
      <>
        <FaInstagram />
      </>
    ),
    link: "https://www.instagram.com/pivotandexplore/",
  },
];

const allSkills = {
  softSkills: [
    {
      name: "Leadership",
      value: 90,
    },
    {
      name: "Organization",
      value: 85,
    },
    {
      name: "Time Management",
      value: 80,
    },
    {
      name: "Prioritization",
      value: 60,
    },
    {
      name: "Planning",
      value: 85,
    },
    {
      name: "Ideation",
      value: 80,
    },
    {
      name: "Teamwork",
      value: 60,
    },
    {
      name: "Coordination",
      value: 85,
    },
    {
      name: "Communication",
      value: 80,
    },
    {
      name: "Mentoring",
      value: 60,
    },
  ],
  technicalLanguages: [
    {
      name: "Javascript",
      value: 90,
      icon: (
        <>
          <SiJavascript />
        </>
      ),
    },
    {
      name: "Typescript",
      value: 90,
      icon: (
        <>
          <SiTypescript />
        </>
      ),
    },
    {
      name: "Java",
      value: 85,
      icon: (
        <>
          <FaJava />
        </>
      ),
    },
    {
      name: "Python",
      value: 80,
      icon: (
        <>
          <FaPython />
        </>
      ),
    },
    {
      name: "HTML",
      value: 60,
      icon: (
        <>
          <FaHtml5 />
        </>
      ),
    },
    {
      name: "CSS",
      value: 85,
      icon: (
        <>
          <FaCss3 />
        </>
      ),
    },
    {
      name: "SCSS",
      value: 85,
      icon: (
        <>
          <BsFiletypeScss />
        </>
      ),
    },
    {
      name: "C",
      value: 60,
      icon: (
        <>
          <TbHexagonLetterC />
        </>
      ),
    },
    {
      name: "C#",
      value: 85,
      icon: (
        <>
          <TbHexagonLetterC />
        </>
      ),
    },
  ],
  technicalSkills: [
    {
      name: "React",
      value: 90,
      icon: (
        <>
          <FaReact />
        </>
      ),
    },
    {
      name: "React Native",
      value: 85,
      icon: (
        <>
          <TbBrandReactNative />
        </>
      ),
    },
    {
      name: "Node.js",
      value: 80,
      icon: (
        <>
          <FaNodeJs />
        </>
      ),
    },
    {
      name: "Angular",
      value: 60,
      icon: (
        <>
          <FaAngular />
        </>
      ),
    },
    {
      name: "Flask",
      value: 85,
      icon: (
        <>
          <SiFlask />
        </>
      ),
    },
    {
      name: ".NET",
      value: 60,
      icon: (
        <>
          <SiDotnet />
        </>
      ),
    },
    {
      name: "Redux Toolkit",
      value: 85,
      icon: (
        <>
          <SiRedux />
        </>
      ),
    },
    {
      name: "Express.js",
      value: 60,
      icon: (
        <>
          <SiExpress />
        </>
      ),
    },
    {
      name: "Axios",
      value: 85,
      icon: (
        <>
          <SiAxios />
        </>
      ),
    },
    {
      name: "Firebase",
      value: 60,
      icon: (
        <>
          <SiFirebase />
        </>
      ),
    },
    {
      name: "PostgreSQL",
      value: 85,
      icon: (
        <>
          <BiLogoPostgresql />
        </>
      ),
    },
    {
      name: "MySQL",
      value: 60,
      icon: (
        <>
          <SiMysql />
        </>
      ),
    },
    {
      name: "MongoDB",
      value: 85,
      icon: (
        <>
          <SiMongodb />
        </>
      ),
    },
    {
      name: "TailwindCSS",
      value: 60,
      icon: (
        <>
          <SiTailwindcss />
        </>
      ),
    },
    {
      name: "Booststrap",
      value: 85,
      icon: (
        <>
          <SiBootstrap />
        </>
      ),
    },
    {
      name: "MUI",
      value: 85,
      icon: (
        <>
          <SiMui />
        </>
      ),
    },
    {
      name: "DialogFlow",
      value: 60,
      icon: (
        <>
          <SiDialogflow />
        </>
      ),
    },
    {
      name: "Discord.js",
      value: 85,
      icon: (
        <>
          <FaDiscord />
        </>
      ),
    },
    {
      name: "Next.js",
      value: 60,
      icon: (
        <>
          <TbBrandNextjs />
        </>
      ),
    },
    {
      name: "Docker",
      value: 85,
      icon: (
        <>
          <FaDocker />
        </>
      ),
    },
    {
      name: "Kubernetes",
      value: 75,
      icon: (
        <>
          <SiKubernetes />
        </>
      ),
    },
    {
      name: "Azure",
      value: 75,
      icon: (
        <>
          <SiMicrosoftazure />
        </>
      ),
    },
    {
      name: "Azure DevOps",
      value: 75,
      icon: (
        <>
          <SiAzuredevops />
        </>
      ),
    },
    {
      name: "CI/CD",
      value: 85,
      icon: (
        <>
          <TbSettingsAutomation />
        </>
      ),
    },
    {
      name: "Entity Framework Core",
      value: 85,
      icon: (
        <>
          <SiDotnet />
        </>
      ),
    },
    {
      name: "REST APIs",
      value: 90,
      icon: (
        <>
          <TbApi />
        </>
      ),
    },
    {
      name: "Microsoft SQL Server",
      value: 80,
      icon: (
        <>
          <DiMsqlServer />
        </>
      ),
    },
    {
      name: "Unit Testing",
      value: 80,
      icon: (
        <>
          <TbTestPipe />
        </>
      ),
    },
    {
      name: "Integration Testing",
      value: 80,
      icon: (
        <>
          <TbTestPipe />
        </>
      ),
    },
  ],
  software: [
    {
      name: "Git",
      value: 90,
      icon: (
        <>
          <BsGithub />
        </>
      ),
    },
    {
      name: "Github",
      value: 85,
      icon: (
        <>
          <DiGithubFull />
        </>
      ),
    },
    {
      name: "VSCode",
      value: 80,
      icon: (
        <>
          <TbBrandVscode />
        </>
      ),
    },
    {
      name: "Figma",
      value: 60,
      icon: (
        <>
          <FaFigma />
        </>
      ),
    },
    {
      name: "Visily",
      value: 85,
      icon: (
        <>
          <TbSquareLetterV />
        </>
      ),
    },
    {
      name: "Postman",
      value: 60,
      icon: (
        <>
          <SiPostman />
        </>
      ),
    },
    {
      name: "Notion",
      value: 85,
      icon: (
        <>
          <SiNotion />
        </>
      ),
    },
    {
      name: "Jira",
      value: 60,
      icon: (
        <>
          <FaJira />
        </>
      ),
    },
    {
      name: "Discord",
      value: 85,
      icon: (
        <>
          <FaDiscord />
        </>
      ),
    },
    {
      name: "Miro",
      value: 85,
      icon: (
        <>
          <SiMiro />
        </>
      ),
    },
  ],
  securitySkills: [
    {
      name: "OWASP Top 10",
      value: 90,
      icon: (
        <>
          <MdSecurity />
        </>
      ),
    },
    {
      name: "Threat Modeling",
      value: 85,
      icon: (
        <>
          <GiShield />
        </>
      ),
    },
    {
      name: "Secure SDLC",
      value: 85,
      icon: (
        <>
          <FaUserShield />
        </>
      ),
    },
    {
      name: "API Security",
      value: 90,
      icon: (
        <>
          <MdOutlineSecurity />
        </>
      ),
    },
    {
      name: "JWT Authentication",
      value: 95,
      icon: (
        <>
          <SiJsonwebtokens />
        </>
      ),
    },
    {
      name: "OAuth2",
      value: 90,
      icon: (
        <>
          <SiAuth0 />
        </>
      ),
    },
    {
      name: "Role-Based Access Control (RBAC)",
      value: 90,
      icon: (
        <>
          <MdAdminPanelSettings />
        </>
      ),
    },
    {
      name: "Identity & Access Management (IAM)",
      value: 85,
      icon: (
        <>
          <RiShieldUserLine />
        </>
      ),
    },
    {
      name: "Security Code Reviews",
      value: 90,
      icon: (
        <>
          <MdSecurity />
        </>
      ),
    },
    {
      name: "Vulnerability Mitigation",
      value: 85,
      icon: (
        <>
          <GiShield />
        </>
      ),
    },
    {
      name: "Secure Architecture",
      value: 85,
      icon: (
        <>
          <FaUserShield />
        </>
      ),
    },
    {
      name: "HTTPS / CSP / CORS",
      value: 90,
      icon: (
        <>
          <MdOutlineSecurity />
        </>
      ),
    },
  ],
};

const skills = allSkills?.technicalSkills;

const hobbies = [
  {
    name: "Listening to Music",
    icon: (
      <>
        <FaHeadphones />
      </>
    ),
  },
  {
    name: "Photography",
    icon: (
      <>
        <FaCamera />
      </>
    ),
  },
  {
    name: "Reading",
    icon: (
      <>
        <FaBook />
      </>
    ),
  },
  {
    name: "Travelling",
    icon: (
      <>
        <FaPlane />
      </>
    ),
  },
];

const sports = [
  {
    name: "Swimming",
    icon: (
      <>
        <FaSwimmer />
      </>
    ),
  },
  {
    name: "Running",
    icon: (
      <>
        <FaRunning />
      </>
    ),
  },
  {
    name: "Basketball",
    icon: (
      <>
        <FaBaseballBall />
      </>
    ),
  },
];
export {
  meta,
  dataabout,
  dataportfolio,
  worktimeline,
  skills,
  projects,
  introdata,
  contactConfig,
  socialprofils,
  logotext,
  education,
  allSkills,
  personalTimeline,
  hobbies,
  sports,
  dataacademic,
  datawork,
  involvements,
  certifications,
  connectList,
  pivotnexploreList,
};
